class IndexedDB {
  constructor(options) {
    this.dbName = options.dbName
    this.version = options.version || 1
    this.schema = options.schema
    this.db = null
  }

  // 打开/初始化数据库
  open() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.version)

      request.onupgradeneeded = (event) => {
        const db = event.target.result
        this._createStores(db)
      }

      request.onsuccess = (event) => {
        this.db = event.target.result
        resolve(this.db)
      }

      request.onerror = (event) => {
        reject(event.target.error)
      }
    })
  }

  // 创建对象存储（表）
  _createStores(db) {
    Object.keys(this.schema).forEach((storeName) => {
      if (!db.objectStoreNames.contains(storeName)) {
        const { keyPath, indexes } = this.schema[storeName]
        const store = db.createObjectStore(storeName, { keyPath })

        if (indexes) {
          indexes.forEach((index) => {
            store.createIndex(index, index, { unique: false })
          })
        }
      }
    })
  }

  // 获取事务
  _getTransaction(storeName, mode = 'readonly') {
    if (!this.db) throw new Error('Database not open')
    return this.db.transaction(storeName, mode).objectStore(storeName)
  }

  // 添加/更新数据
  set(storeName, data) {
    return new Promise((resolve, reject) => {
      const store = this._getTransaction(storeName, 'readwrite')
      const request = store.put(data)

      request.onsuccess = () => resolve(data)
      request.onerror = (event) => reject(event.target.error)
    })
  }

  // 获取数据（通过主键）
  get(storeName, key) {
    return new Promise((resolve, reject) => {
      const store = this._getTransaction(storeName)
      const request = store.get(key)

      request.onsuccess = () => resolve(request.result)
      request.onerror = (event) => reject(event.target.error)
    })
  }

  // 删除数据
  delete(storeName, key) {
    return new Promise((resolve, reject) => {
      const store = this._getTransaction(storeName, 'readwrite')
      const request = store.delete(key)

      request.onsuccess = () => resolve()
      request.onerror = (event) => reject(event.target.error)
    })
  }

  // 查询所有数据
  getAll(storeName) {
    return new Promise((resolve, reject) => {
      const store = this._getTransaction(storeName)
      const request = store.getAll()

      request.onsuccess = () => resolve(request.result)
      request.onerror = (event) => reject(event.target.error)
    })
  }

  // 通过索引查询
  getByIndex(storeName, indexName, value) {
    return new Promise((resolve, reject) => {
      const store = this._getTransaction(storeName)
      const index = store.index(indexName)
      const request = index.getAll(value)

      request.onsuccess = () => resolve(request.result)
      request.onerror = (event) => reject(event.target.error)
    })
  }

  // 关闭数据库
  close() {
    this.db?.close()
  }
}

export default IndexedDB
